import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  logoutButton: (theme: Theme) => ({
    fontWeight: 600,
    color: theme.colors.secondary[800],
    flexGrow: 0,
    alignSelf: 'flex-end',

    '&:hover': {
      backgroundColor: alpha(theme.colors.white, 0.2),
    },
  }),
  userName: (theme: Theme) => ({
    color: theme.colors.secondary[800],
    fontWeight: 600,
    fontSize: theme.typography.button.fontSize,
    lineHeight: 1,
  }),
};
